import styled from 'styled-components';

export const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Swiss721 BT', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--color-set-brand-alt-color, #707070);
  white-space: nowrap;
  gap: 0px;
  align-items: baseline;

  span {
    display: inline-block;
    font-size: 12px;
  }
`;

export const Separator = styled.span`
  line-height: 1.5;
  color: var(--color-set-brand-alt-color, #707070) !important;
  padding: 0 4px;
`;

export const LocationIcon = styled.span`
  line-height: 1.5;
  color: var(--color-set-brand-alt-color, #707070) !important;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px !important;
  height: 12px !important;
  flex-shrink: 0;
  margin-right: 6px;

  svg {
    width: 12px;
    height: 12px;
  }
`;
